module.exports = __webpack_public_path__ + "static/media/fashion.bf4da8ee.jpg";